







































































































































































































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import { AxiosStatic } from "axios";
import ResourceEmailText from "@/components/ResourceEmailText.vue";
import IResource from "@/interfaces/IResource";
import SettingsCustomfields from "@/components/SettingsCustomfields.vue";
import SettingsLocktimes from "@/components/SettingsLocktimes.vue";
import CalendarTypeSelector from "@/components/CalendarTypeSelector.vue";
import SettingsResourceimages from '@/components/SettingsResourceimages.vue';

const enum States { LOADING = 0, LOADING_ERROR = 1, READY = 2, SAVING = 3, SAVING_ERROR = 4 }

@Component({
	components: {
		ResourceEmailText,
		SettingsCustomfields,
		SettingsLocktimes,
		SettingsResourceimages,
		CalendarTypeSelector
	}
})
export default class Settings extends Vue {

	public state: States = States.LOADING;

	public tab: 'settings' | 'customfields' | 'emailtexts' = 'settings';

	public name: string = '';
	public description: string | null = '';
	public logo: string | null = '';
	public starttime: number | null = null;
	public endtime: number | null = null;
	public slot_size: number = 30;
	public max_duration: number = 0;
	public min_hours_to_reservation: number = 1;
	public max_hours_to_reservation: number = 0;
	public auto_confirm: number = 0;
	public reservation_customer_editable: number = 0;
	public reservation_show_details: number = 0;
	public reservation_show_state: number = 0;
	public calendarType: 'multiday' | 'singleday' = 'singleday';
	public showFooter: boolean = true;

	public checkin_time_enabled: number = 0;
	public checkin_time: number = 0;
	public checkout_time: number = 0;

	public delete_logo: boolean = false;

	public showInvalidFileSize: boolean = false;
	public showInvalidFileExtension: boolean = false;
	public isUploading: boolean = false;

	private $http!: AxiosStatic;

	public $refs!: {
		uploader: HTMLInputElement;
	};

	get resourceId(): number {
		return parseInt((<any>this.$route.params).id || 0);
	}

	get hasError(): boolean {
		return this.name.length == 0 || typeof this.starttime !== 'number' || this.starttime >= this.endtime!;
	}

	get resource(): IResource | null {
		if (this.$store.state.resources) {
			let filtered = this.$store.state.resources.filter((r: IResource) => r.id == this.resourceId);
			if (filtered.length > 0) {
				return filtered[0];
			}
		}
		return null;
	}

	get logoUrl(): string {
		if (this.logo) {
			return '/' + this.logo;
		} else {
			return '';
		}
	}

	@Watch('resource', { immediate: true})
	public watchResource() {
		if (this.resource !== null) {
			this.state = States.READY;
			this.name = this.resource.name;
			this.description = this.resource.description || '';
			this.starttime = this.resource.starttime;
			this.endtime = this.resource.endtime;
			this.slot_size = this.resource.slot_size;
			this.min_hours_to_reservation = this.resource.min_hours_to_reservation;
			this.max_hours_to_reservation = this.resource.max_hours_to_reservation;
			this.max_duration = this.resource.max_duration;
			this.auto_confirm = this.resource.auto_confirm;
			this.reservation_customer_editable = this.resource.reservation_customer_editable;
			this.reservation_show_details = this.resource.reservation_show_details;
			this.reservation_show_state = this.resource.reservation_show_state;
			this.calendarType = this.resource.type;
			this.logo = this.resource.logo;
			this.checkin_time_enabled = this.resource.checkin_time_enabled;
			this.checkin_time = this.resource.checkin_time;
			this.checkout_time = this.resource.checkout_time;
		}
	}

	public async mounted(): Promise<void> {
		this.$store.dispatch('loadResources', {root: true});
		this.$store.dispatch('loadSubscription', {root: true});
		this.$store.dispatch('loadOrganisation', {root: true});
	}

	public save() {
		if (this.name.length > 0 && typeof this.starttime === 'number' && this.starttime < this.endtime! && this.resource) {
			this.state = States.SAVING;

			let formData = new FormData();
			formData.append('name', this.name);
			if (this.description != null ) { formData.append('description', this.description) }
			if (this.starttime != null ) { formData.append('starttime', String(this.starttime)) }
			if (this.endtime != null ) { formData.append('endtime', String(this.endtime)) }
			if (this.slot_size != null ) { formData.append('slot_size', String(this.slot_size)) }
			if (this.max_duration != null ) { formData.append('max_duration', String(this.max_duration)) }
			if (this.min_hours_to_reservation != null ) { formData.append('min_hours_to_reservation', String(this.min_hours_to_reservation)) }
			if (this.max_hours_to_reservation != null ) { formData.append('max_hours_to_reservation', String(this.max_hours_to_reservation)) }
			if (this.resource.confirmation_email_text != null ) { formData.append('confirmation_email_text', this.resource.confirmation_email_text) }
			if (this.resource.reservation_email_text != null ) { formData.append('reservation_email_text', this.resource.reservation_email_text) }
			if (this.resource.change_reservation_email_text != null ) { formData.append('change_reservation_email_text', this.resource.change_reservation_email_text) }
			if (this.checkin_time != null ) { formData.append('checkin_time', String(this.checkin_time)) }
			if (this.checkout_time != null ) { formData.append('checkout_time', String(this.checkout_time)) }
			formData.append('auto_confirm', this.auto_confirm.toString());
			formData.append('checkin_time_enabled', this.checkin_time_enabled.toString());
			formData.append('reservation_customer_editable', this.reservation_customer_editable.toString())
			formData.append('reservation_show_details', this.reservation_show_details.toString());
			formData.append('reservation_show_state', this.reservation_show_state.toString());
			formData.append('type', this.calendarType);

			if (this.delete_logo) {
				formData.append('delete_logo', 'true')
			} else {
				if (this.$refs.uploader && this.$refs.uploader.files && this.$refs.uploader.files.length > 0) {
					formData.append('logo', this.$refs.uploader.files[0])
				}
			}

			this.$http.post(
				`/private/resource/${this.resourceId}`,
				formData,
				{
					headers: {
						'Content-Type': 'multipart/form-data'
					}
				}
			).then(() => {
				this.state = States.READY;
				this.delete_logo = false;
				this.showInvalidFileExtension = false;
				this.isUploading = false;
				this.$store.dispatch('loadResources', {root: true});
			}).catch((error) => {
				this.delete_logo = false;
				this.state = States.SAVING_ERROR;
			});
		}
	}

	public checkImage(): void {

		// abort if already uploading
		if (this.isUploading) {
			return;
		}

		if (this.$refs.uploader && this.$refs.uploader.files && this.$refs.uploader.files.length > 0) {

			this.isUploading = true;
			this.showInvalidFileExtension = false;
			this.showInvalidFileSize = false;

			let allowedExtensions = ['jpeg', 'png', 'jpg', 'gif'];

			let fileName: string = this.$refs.uploader.files[0].name.toLowerCase();
			let fileExt = fileName.substr(fileName.lastIndexOf('.') + 1);
			if (allowedExtensions.includes(fileExt)) {
				let reader: FileReader = new FileReader();
				reader.onload = (e: any) => {
					try {
						let contents: string = e.target.result;
						this.isUploading = false;
						if (contents.length > 1024*1024) {
							this.showInvalidFileSize = true;
						}
					} catch (e) {
						this.showInvalidFileExtension = true;
						this.isUploading = false;
					}
				};
				reader.readAsBinaryString(this.$refs.uploader.files[0]);
				reader.onerror = () => {
					this.showInvalidFileExtension = true;
					this.isUploading = false;
				};
			} else {
				this.$refs.uploader.value = '';
				this.showInvalidFileExtension = true;
				this.isUploading = false;
			}
		}
	}
}
